<footer class="legal-footer">
  <p>© {{ currentDate | date: 'yyyy' }} YokaStar. Tous droits réservés.</p>
  <p class="legal-footer-links">
    <a routerLink="/privacy-policy">Politique de confidentialité</a>
    <span class="legal-footer-sep" aria-hidden="true">|</span>
    <a routerLink="/terms">Conditions d'utilisation</a>
    <span class="legal-footer-sep" aria-hidden="true">|</span>
    <a routerLink="/cookies">Politique relative aux cookies</a>
    <span class="legal-footer-sep" aria-hidden="true">|</span>
    <a routerLink="/child-safety">Protection des enfants (CSAE)</a>
    <span class="legal-footer-sep" aria-hidden="true">|</span>
    <a routerLink="/contact">Nous contacter</a>
  </p>
</footer>
